export default __webpack_public_path__ + "static/media/explore.b701379c.png";